export { sprintf } from './sprintf';
export * from './create-i18n';
export {
	default as defaultI18n,
	setLocaleData,
	resetLocaleData,
	getLocaleData,
	subscribe,
	__,
	_x,
	_n,
	_nx,
	isRTL,
	hasTranslation,
} from './default-i18n';
